import { redoCoreMessageSchema } from "@redotech/redo-model/ai/core-message/core-message";
import { z } from "zod";

// Define schema for tool options
const toolOptionSchema = z
  .object({ isDisabled: z.boolean().optional() })
  .catchall(z.any());

// Define the schema for all tool options
const toolOptionsSchema = z.record(toolOptionSchema);

export const sendMessage = {
  input: z.object({
    messages: z.array(redoCoreMessageSchema),
    options: toolOptionsSchema.optional(),
  }),
  output: z.object({ messages: z.array(redoCoreMessageSchema) }),
};
